import { HeaderProps } from "@/components/_rebrand/Header";
import Icon from "@/components/_rebrand/Icon";
import IconArrowFooterLink from "@/components/_rebrand/IconArrowFooterLink";
import Image from "next/image";
import Link from "next/link";
import { ACADEMY_LINK, ACCOUNT_MANAGEMENT_LINK, AUTOPILOT_LINK, BLOG_LINK, CHANNEL_PARTNERSHIPS_LINK, CLIENT_COMMUNICATION_LINK, COMMUNITY_LINK, COMPASS_LINK, COPILOT_LINK, CUSTOMER_SERVICE_LINK, CUSTOMER_STORIES_LINK, CUSTOMER_SUPPORT_LINK, DEVELOPER_PORTAL_LINK, DOWNLOAD_APP_LINK, EMAIL_MANAGEMENT_LINK, EXTERNAL_AGENT_LINK, FINANCIAL_SERVICES_LINK, GUIDES_WEBINARS_LINK, HELP_CENTER_LINK, INBOUND_SALES_LINK, INTEGRATIONS_API_LINK, INTEGRATIONS_LINK, KNOWLEDGE_BASE_LINK, RESOLVE_LINK, LOGISTICS_LINK, MANUFACTURING_LINK, OMNICHANNEL_LINK, OPERATIONS_LINK, PRODUCT_LINK, PRODUCT_TOUR_LINK, PROFESSIONAL_SERVICES_LINK, SECURITY_LINK, SUCCESS_LINK, SUPPORT_REPORT_LINK, TECHNOLOGY_LINK, TICKETING_LINK, TRAVEL_LINK, WHATS_NEW_LINK } from "./navigation-links";

export const PROMO_BANNER_LINK = '/blog/ai-agents-teammates-launch';

const HEADER_PROPS = {
  desktopMenu: [
    {
      type: 'drawer' as const,
      title: 'Product',
      sections: [
        {
          image: (
            <Link href={PRODUCT_TOUR_LINK.href} className="w-full block">
              <div className="flex items-center justify-between mb-2">
                <span className="text-16/20 font-500">See Front in Action</span>
                <IconArrowFooterLink className="block" />
              </div>
              <Image src="https://front.com/assets/pages/global-ai/Nav/Front-Overview-Thumbnail.png" width={330} height={195} alt="Front Product Interface Screenshot" />
            </Link>
          ),
          featuredLinks: [
            { title: 'Platform Overview', href: PRODUCT_LINK.href },
            { title: 'Recent Product Updates', href: WHATS_NEW_LINK.href },
          ],
        },
        {
          title: 'Use Cases',
          linkColumns: 1 as const,
          links: [
            {
              ...CUSTOMER_SERVICE_LINK,
              icon: <Image src={CUSTOMER_SERVICE_LINK.icon.svgUrl} width={14} height={14} alt={CUSTOMER_SERVICE_LINK.icon.alt} />,
            },
            {
              ...EMAIL_MANAGEMENT_LINK,
              icon: <Image src={EMAIL_MANAGEMENT_LINK.icon.svgUrl} width={14} height={14} alt={EMAIL_MANAGEMENT_LINK.icon.alt} />,
            },
            {
              ...CLIENT_COMMUNICATION_LINK,
              icon: <Image src={CLIENT_COMMUNICATION_LINK.icon.svgUrl} width={14} height={14} alt={CLIENT_COMMUNICATION_LINK.icon.alt} />,
            },
          ],
        },
        {
          title: 'AI Platform',
          linkColumns: 1 as const,
          links: [
            {
              ...AUTOPILOT_LINK,
              icon: <Image src={AUTOPILOT_LINK.icon.svgUrl} width={14} height={14} alt={AUTOPILOT_LINK.icon.alt} />,
            },
            {
              ...COPILOT_LINK,
              icon: <Image src={COPILOT_LINK.icon.svgUrl} width={14} height={14} alt={COPILOT_LINK.icon.alt} />,
            },
            {
              ...COMPASS_LINK,
              icon: <Icon name="line-chart-up-01" size={16} />,
              subtitle: 'Make sure your AI agents measure up',
            },
            {
              ...EXTERNAL_AGENT_LINK,
              icon: <Icon name="user-sparkle-01" size={16} />,
              subtitle: 'Let any AI agent join the team',
            },
          ],
        },
        {
          title: 'More Features',
          linkColumns: 1 as const,
          links: [
            {
              ...OMNICHANNEL_LINK,
              icon: <Image src={OMNICHANNEL_LINK.icon.svgUrl} width={14} height={14} alt={OMNICHANNEL_LINK.icon.alt} />,
            },
            {
              ...TICKETING_LINK,
              icon: <Image src={TICKETING_LINK.icon.svgUrl} width={14} height={14} alt={TICKETING_LINK.icon.alt} />,
            },
            {
              ...RESOLVE_LINK,
              title: 'Resolve',
              icon: <Image src={RESOLVE_LINK.icon.svgUrl} width={14} height={14} alt={RESOLVE_LINK.icon.alt} />,
            },
            {
              ...KNOWLEDGE_BASE_LINK,
              title: 'Knowledge Base',
              icon: <Image src={KNOWLEDGE_BASE_LINK.icon.svgUrl} width={14} height={14} alt={KNOWLEDGE_BASE_LINK.icon.alt} />,
            },
            {
              ...INTEGRATIONS_API_LINK,
              icon: <Image src={INTEGRATIONS_API_LINK.icon.svgUrl} width={14} height={14} alt={INTEGRATIONS_API_LINK.icon.alt} />,
            },
          ],
        },
      ],
    },
    {
      type: 'drawer' as const,
      title: 'Solutions',
      sections: [
        {
          title: 'Industries',
          linkColumns: 2 as const,
          links: [
            {
              ...TECHNOLOGY_LINK,
              icon: <Image src={TECHNOLOGY_LINK.icon.svgUrl} width={14} height={14} alt={TECHNOLOGY_LINK.icon.alt} />,

            },
            {
              ...FINANCIAL_SERVICES_LINK,
              icon: <Image src={FINANCIAL_SERVICES_LINK.icon.svgUrl} width={14} height={14} alt={FINANCIAL_SERVICES_LINK.icon.alt} />,
            },
            {
              ...LOGISTICS_LINK,
              icon: <Image src={LOGISTICS_LINK.icon.svgUrl} width={14} height={14} alt={LOGISTICS_LINK.icon.alt} />,
            },
            {
              ...MANUFACTURING_LINK,
              icon: <Image src={MANUFACTURING_LINK.icon.svgUrl} width={14} height={14} alt={MANUFACTURING_LINK.icon.alt} />,
            },
            {
              ...PROFESSIONAL_SERVICES_LINK,
              icon: <Image src={PROFESSIONAL_SERVICES_LINK.icon.svgUrl} width={14} height={14} alt={PROFESSIONAL_SERVICES_LINK.icon.alt} />,
            },
            {
              ...TRAVEL_LINK,
              icon: <Image src={TRAVEL_LINK.icon.svgUrl} width={14} height={14} alt={TRAVEL_LINK.icon.alt} />,
            },
          ],
        },
        {
          title: 'Teams',
          linkColumns: 2 as const,
          links: [
            {
              ...CUSTOMER_SUPPORT_LINK,
              icon: <Image src={CUSTOMER_SUPPORT_LINK.icon.svgUrl} width={14} height={14} alt={CUSTOMER_SUPPORT_LINK.icon.alt} />,
            },
            {
              ...OPERATIONS_LINK,
              icon: <Image src={OPERATIONS_LINK.icon.svgUrl} width={14} height={14} alt={OPERATIONS_LINK.icon.alt} />,
            },
            {
              ...INBOUND_SALES_LINK,
              icon: <Image src={INBOUND_SALES_LINK.icon.svgUrl} width={14} height={14} alt={INBOUND_SALES_LINK.icon.alt} />,
            },
            {
              ...ACCOUNT_MANAGEMENT_LINK,
              icon: <Image src={ACCOUNT_MANAGEMENT_LINK.icon.svgUrl} width={14} height={14} alt={ACCOUNT_MANAGEMENT_LINK.icon.alt} />,
            },
            {
              ...SUCCESS_LINK,
              icon: <Image src={SUCCESS_LINK.icon.svgUrl} width={14} height={14} alt={SUCCESS_LINK.icon.alt} />,
            },
          ],
        },
      ],
      /*
       * promoBanner: (
       *  <div className="px-2 py-[12px] rounded-10 bg-blue-100 hover:bg-blue-200 transition-colors duration-200 ease-in-out-quad relative">
       *  <a href="https://front.com/startups" className="link-cover">
       *  Front for Startups: Stand out with exceptional support from day 1 &#8594;
       *  </a>
       * </div>
       * ),
       */
    },
    {
      type: 'drawer' as const,
      title: 'Resources',
      sections: [
        {
          title: 'Using Front',
          links: [
            { ...ACADEMY_LINK },
            { ...COMMUNITY_LINK },
            { ...HELP_CENTER_LINK },
            { ...DEVELOPER_PORTAL_LINK },
          ],
        },
        {
          title: 'Explore',
          linkColumns: 2 as const,
          links: [
            { ...BLOG_LINK },
            { ...INTEGRATIONS_LINK },
            { ...GUIDES_WEBINARS_LINK },
            { ...SECURITY_LINK },
            { ...CUSTOMER_STORIES_LINK },
            { ...DOWNLOAD_APP_LINK },
            { ...SUPPORT_REPORT_LINK },
            { ...CHANNEL_PARTNERSHIPS_LINK },
          ],
        },
        {
          /*
           * image: <div className="w-full bg-violet-50 aspect-video" />,
           */
          image: (
            <Link href="https://front.registration.goldcast.io/series/f7a5a6e2-a125-4eff-90cc-ea68f93122c3" className="w-full block max-h-19" target="_blank">
              <Image
                src="https://front.com/assets/resources/four-sessions-or-running-agents.png"
                width={960}
                height={427}
                alt="Webinar series: running agents in customer work"
              />
            </Link>
          ),
          featuredLinks: [{
            title: `Four sessions on running agents in customer ops, without losing control`,
            href: 'https://front.registration.goldcast.io/series/f7a5a6e2-a125-4eff-90cc-ea68f93122c3',
            target: '_blank',
          }],
        },
      ],
    },
    {
      type: 'link' as const,
      title: 'Pricing',
      href: '/pricing',
    },
  ],

  desktopMenuLinks: [
    {
      type: 'link' as const,
      title: 'Sign in',
      href: 'https://app.frontapp.com/signin',
    },
    {
      type: 'primary' as const,
      title: 'Request a demo',
      href: '',
      action: 'demo' as const,
    },
    {
      type: 'secondary' as const,
      title: 'Try for free',
      href: '',
      action: 'trial' as const,
    },
  ],
  mobileMenu: [
    {
      type: 'drawer' as const,
      title: 'Product',
      sections: [
        {
          title: 'Use Cases',
          links: [
            {
              ...CUSTOMER_SERVICE_LINK,
              icon: <Image src={CUSTOMER_SERVICE_LINK.icon.svgUrl} width={24} height={24} alt={CUSTOMER_SERVICE_LINK.icon.alt} className="block" key={`${CUSTOMER_SERVICE_LINK.title}-icon-1`} />,
            },
            {
              ...EMAIL_MANAGEMENT_LINK,
              icon: <Image src={EMAIL_MANAGEMENT_LINK.icon.svgUrl} width={24} height={24} alt={EMAIL_MANAGEMENT_LINK.icon.alt} className="block" key={`${EMAIL_MANAGEMENT_LINK.title}-icon-2`} />,
            },
            {
              ...CLIENT_COMMUNICATION_LINK,
              icon: <Image src={CLIENT_COMMUNICATION_LINK.icon.svgUrl} width={24} height={24} alt={CLIENT_COMMUNICATION_LINK.icon.alt} className="block" key={`${CLIENT_COMMUNICATION_LINK.title}-icon-3`} />,
            },
          ],
        },
        {
          title: 'AI Platform',
          links: [
            {
              ...AUTOPILOT_LINK,
              icon: <Image src={AUTOPILOT_LINK.icon.svgUrl} width={24} height={24} alt={AUTOPILOT_LINK.icon.alt} className="block" key={`${AUTOPILOT_LINK.title}-icon-2`} />,
            },
            {
              ...COPILOT_LINK,
              icon: <Image src={COPILOT_LINK.icon.svgUrl} width={24} height={24} alt={COPILOT_LINK.icon.alt} className="block" key={`${COPILOT_LINK.title}-icon-3`} />,
            },
            {
              ...COMPASS_LINK,
              icon: <Icon name="line-chart-up-01" size={20} className="block" key={`${COMPASS_LINK.title}-icon-4`} />,
            },
            {
              ...EXTERNAL_AGENT_LINK,
              icon: <Icon name="user-sparkle-01" size={20} className="block" key={`${EXTERNAL_AGENT_LINK.title}-icon-5`} />,
            },
          ],
        },
        {
          title: 'More Features',
          links: [
            {
              ...OMNICHANNEL_LINK,
              icon: <Image src={OMNICHANNEL_LINK.icon.svgUrl} width={24} height={24} alt={OMNICHANNEL_LINK.icon.alt} className="block" key={`${OMNICHANNEL_LINK.title}-icon-1`} />,
            },
            {
              ...TICKETING_LINK,
              icon: <Image src={TICKETING_LINK.icon.svgUrl} width={24} height={24} alt={TICKETING_LINK.icon.alt} className="block" key={`${TICKETING_LINK.title}-icon-2`} />,
            },
            {
              ...RESOLVE_LINK,
              title: 'Resolve',
              icon: <Image src={RESOLVE_LINK.icon.svgUrl} width={24} height={24} alt={RESOLVE_LINK.icon.alt} className="block" key={`${RESOLVE_LINK.title}-icon-3`} />,
            },
            {
              ...KNOWLEDGE_BASE_LINK,
              title: 'Knowledge Base',
              icon: <Image src={KNOWLEDGE_BASE_LINK.icon.svgUrl} width={24} height={24} alt={KNOWLEDGE_BASE_LINK.icon.alt} className="block" key={`${KNOWLEDGE_BASE_LINK.title}-icon-4`} />,
            },
            {
              ...INTEGRATIONS_API_LINK,
              icon: <Image src={INTEGRATIONS_API_LINK.icon.svgUrl} width={24} height={24} alt={INTEGRATIONS_API_LINK.icon.alt} className="block" key={`${INTEGRATIONS_API_LINK.title}-icon-5`} />,
            },
          ],
        },
      ],
    },
    {
      type: 'drawer' as const,
      title: 'Solutions',
      sections: [
        {
          title: 'Industries',
          links: [
            {
              ...TECHNOLOGY_LINK,
              icon: <Image src={TECHNOLOGY_LINK.icon.svgUrl} width={24} height={24} alt={TECHNOLOGY_LINK.icon.alt} className="block" key={`${TECHNOLOGY_LINK.title}-icon-1`} />,
            },
            {
              ...FINANCIAL_SERVICES_LINK,
              icon: <Image src={FINANCIAL_SERVICES_LINK.icon.svgUrl} width={24} height={24} alt={FINANCIAL_SERVICES_LINK.icon.alt} className="block" key={`${FINANCIAL_SERVICES_LINK.title}-icon-2`} />,
            },
            {
              ...LOGISTICS_LINK,
              icon: <Image src={LOGISTICS_LINK.icon.svgUrl} width={24} height={24} alt={LOGISTICS_LINK.icon.alt} className="block" key={`${LOGISTICS_LINK.title}-icon-3`} />,
            },
            {
              ...MANUFACTURING_LINK,
              icon: <Image src={MANUFACTURING_LINK.icon.svgUrl} width={24} height={24} alt={MANUFACTURING_LINK.icon.alt} className="block" key={`${MANUFACTURING_LINK.title}-icon-4`} />,
            },
            {
              ...PROFESSIONAL_SERVICES_LINK,
              icon: <Image src={PROFESSIONAL_SERVICES_LINK.icon.svgUrl} width={24} height={24} alt={PROFESSIONAL_SERVICES_LINK.icon.alt} className="block" key={`${PROFESSIONAL_SERVICES_LINK.title}-icon-5`} />,
            },
            {
              ...TRAVEL_LINK,
              icon: <Image src={TRAVEL_LINK.icon.svgUrl} width={24} height={24} alt={TRAVEL_LINK.icon.alt} className="block" key={`${TRAVEL_LINK.title}-icon-6`} />,
            },
          ],
        },
        {
          title: 'Teams',
          links: [
            {
              ...CUSTOMER_SUPPORT_LINK,
              icon: <Image src={CUSTOMER_SUPPORT_LINK.icon.svgUrl} width={24} height={24} alt={CUSTOMER_SUPPORT_LINK.icon.alt} className="block" key={`${CUSTOMER_SUPPORT_LINK.title}-icon-7`} />,
            },
            {
              ...OPERATIONS_LINK,
              icon: <Image src={OPERATIONS_LINK.icon.svgUrl} width={24} height={24} alt={OPERATIONS_LINK.icon.alt} className="block" key={`${OPERATIONS_LINK.title}-icon-8`} />,
            },
            {
              ...INBOUND_SALES_LINK,
              icon: <Image src={INBOUND_SALES_LINK.icon.svgUrl} width={24} height={24} alt={INBOUND_SALES_LINK.icon.alt} className="block" key={`${INBOUND_SALES_LINK.title}-icon-9`} />,
            },
            {
              ...ACCOUNT_MANAGEMENT_LINK,
              icon: <Image src={ACCOUNT_MANAGEMENT_LINK.icon.svgUrl} width={24} height={24} alt={ACCOUNT_MANAGEMENT_LINK.icon.alt} className="block" key={`${ACCOUNT_MANAGEMENT_LINK.title}-icon-10`} />,
            },
            {
              ...SUCCESS_LINK,
              icon: <Image src={SUCCESS_LINK.icon.svgUrl} width={24} height={24} alt={SUCCESS_LINK.icon.alt} className="block" key={`${SUCCESS_LINK.title}-icon-11`} />,
            },
          ],
        },
      ],
    },
    {
      type: 'drawer' as const,
      title: 'Resources',
      sections: [
        {
          title: 'Using Front',
          links: [
            {
              ...ACADEMY_LINK,
            },
            {
              ...COMMUNITY_LINK,
            },
            {
              ...HELP_CENTER_LINK,
            },
            {
              ...DEVELOPER_PORTAL_LINK,
            },
          ],
        },
        {
          title: 'Explore',
          links: [
            {
              ...BLOG_LINK,
            },
            {
              ...INTEGRATIONS_LINK,
            },
            {
              ...GUIDES_WEBINARS_LINK,
            },
            {
              ...SECURITY_LINK,
            },
            {
              ...CUSTOMER_STORIES_LINK,
            },
            {
              ...DOWNLOAD_APP_LINK,
            },
            {
              ...SUPPORT_REPORT_LINK,
            },
            {
              ...CHANNEL_PARTNERSHIPS_LINK,
            },
          ],
        },
      ],
    },
    {
      type: 'link' as const,
      title: 'Pricing',
      href: '/pricing',
    },
    {
      type: 'link' as const,
      title: 'Sign in',
      href: 'https://app.frontapp.com/signin',
    },
  ],
  mobileMenuLinks: [
    {
      type: 'primary' as const,
      title: 'Request a demo',
      href: '',
      action: 'demo' as const,
    },
    {
      type: 'secondary' as const,
      title: 'Try for free',
      href: '',
      action: 'trial' as const,
    },
  ],
  promoBanner: (
    <div className="bg-citron-100 hover:bg-citron-500 duration-200 transition-colors ease-in-out-quad text-citron-900 p-1 md:p-[14px] text-center text-12/16 md:text-14/20 relative">
      <Link href={`${PROMO_BANNER_LINK}?src=hellobar`} className="link-cover">
        <span className="font-500">Introducing:</span> a new way for customer teams and AI agents to work together. <span className="underline">Read it now →</span>
      </Link>
    </div>
  ),
} as const satisfies HeaderProps;

export const BLOG_HEADER_PROPS = {
  ...HEADER_PROPS,
  hasGlobalBanner: false
} as const satisfies HeaderProps;

export const BLOG_HEADER_PROPS_WITHOUT_PROMO_BANNER = {
  ...BLOG_HEADER_PROPS,
  promoBanner: null,
}

export default HEADER_PROPS;
